"use client";

import React, { useState } from "react";
import Image from "next/image";
import GlobalForm from "@/components/forms/GlobalForm";
import {
  FormHeading,
  OtherFormCategory,
  SuccessMessageType,
} from "@/interface/types";
import ChatWithUs from "./ChatWithUs";

const indiaCities = [
  {
    name: "Bangalore",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/contact-us/bangalore_offc_desktop.webp",
    address:
      "2nd Floor, Mantri Avenue, Koramangala 8th Block, Bangalore - 560047",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "bangalore@mileseducation.com",
    link: "/cpa/best-cpa-course-in-bangalore",
  },
  {
    name: "Hyderabad",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/contact-us/hyderabad_offc_desktop.webp",
    address:
      "Level - 1, Jayabheri Silicon Towers, Hitech City Road, Kothaguda, Hyderabad - 500084",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "hyderabad@mileseducation.com",
    link: "/cpa/certified-public-accountant-course-in-hyderabad",
  },
  {
    name: "Mumbai",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/contact-us/mumbai_offc_desktop.webp",
    address:
      "1st Floor, AJ House Abengoa, Marol Maroshi Rd, Gamdevi, Marol, Andheri East, Mumbai, Maharashtra 400059",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "mumbai@mileseducation.com",
    link: "/cpa/cpa-course-fees-in-mumbai",
  },
  {
    name: "Delhi",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/contact-us/delhi_offc_desktop.webp",
    address:
      "3rd and 4th Floor, Old Fort Building, Near DLF Mall, Main Road, Saket, New Delhi, Delhi 110017",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "delhincr@mileseducation.com",
    link: "/cpa/cpa-coaching-in-delhi",
  },
  {
    name: "Pune",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/contact-us/pune_offc_desktop.webp",
    address:
      "Sprint Workspace Wakadewadi, Old Mumbai - Pune Hwy, Narveer Tanaji Wadi, Shivajinagar, Pune, Maharashtra 411005",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "pune@mileseducation.com",
    link: "/cpa/cpa-course-fees-in-pune",
  },
  {
    name: "Ahmedabad",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/contact-us/ahmedabad_offc_desktop.webp",
    address:
      "704 Satyaone Complex, Near Helmet Cross Road, Memnagar, Ahmedabad - 380052",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "ahmedabad@mileseducation.com",
    link: "/cpa/best-cpa-course-in-ahmedabad",
  },
  {
    name: "Ernakulam",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/contact-us/kochi_offc_desktop.webp",
    address:
      "11th Floor, Muthoottu Royal tower, 36, Banerji Road, Kaloor, Ernakulam, Kerala 682017",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "kochi@mileseducation.com",
    link: "/cpa/cpa-course-in-kerala",
  },
  {
    name: "Chennai",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/contact-us/chennai_offc_desktop.webp",
    address:
      "3rd Floor, 91 Springboard, Etica Malar Aurum, B-12, Guindy Industrial Estate, SIDCO Industrial Estate, Guindy, Chennai, Tamil Nadu 600032",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "chennai@mileseducation.com",
    link: "/cpa/best-cpa-course-in-chennai",
  },
  {
    name: "Kolkata",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/contact-us/kolkata_offc_desktop.webp",
    address:
      "Collab Deck, 2/1, Russel St, Kankaria Estates, Park Street area, Kolkata, West Bengal 700071",
    phone: "+91-9513881313",
    phone_no: "91-9513881313",
    email: "kolkata@mileseducation.com",
    link: "/cpa/cpa-coaching-in-kolkata",
  },
];

const intlCities = [
  {
    name: "New York",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/contact-us/new_york_offc_desktop.webp",
    address: "Miles Talent Hub, 100 United Nations Plaza, Apt#45C, NYC 10017",
    phone: "+1-347-301-9910",
    phone_no: "1-347-301-9910",
    email: "rohini.sripada@mileseducation.com",
    link: "",
  },
  {
    name: "Dubai",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/contact-us/dubai_offc_desktop.webp",
    address:
      "Miles CareerGraph DMCC, Jumeirah Bay Tower X2, 3rd Floor, Jumeirah Lakes Towers PO BOX 126845, Dubai - UAE, Nearest Metro SHOBHA REALTY",
    phone: "+971-506087199",
    phone_no: "971-506087199",
    email: "yavanika.meru@mileseducation.com",
    link: "",
  },
  {
    name: "San Francisco",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/contact-us/san_fransisco_offc_desktop.webp",
    address: "399 Fremont Street, San Francisco 94105",
    phone: "+1-347-301-9910",
    phone_no: "1-347-301-9910",
    email: "rohini.sripada@mileseducation.com",
    link: "",
  },
];

const GlobalPresenceDesktop = () => {
  const [activeIndia, setActiveIndia] = useState(indiaCities[0].name);
  const [activeIntl, setActiveIntl] = useState(intlCities[0].name);
  const [isFormModelOpenIndia, setIsFormModelOpenIndia] = useState(false);
  const [isFormModelOpenInternational, setIsFormModelOpenInternational] =
    useState(false);
  const [modalDefaultCity, setModalDefaultCity] = useState<string | null>(null);

  const handleFormModelOpenIndia = (cityName: string) => {
    setModalDefaultCity(cityName);
    setIsFormModelOpenIndia(true);
  };

  const handleFormModelCloseIndia = () => {
    setModalDefaultCity(null);
    setIsFormModelOpenIndia(false);
  };

  const handleFormModelOpenInternational = () => {
    setIsFormModelOpenInternational(true);
  };

  const handleFormModelCloseInternational = () => {
    setIsFormModelOpenInternational(false);
  };

  const activeIndiaCity = indiaCities.find((c) => c.name === activeIndia)!;
  const activeIntlCity = intlCities.find((c) => c.name === activeIntl)!;

  const buttonClasses =
    "inline-block md:px-5 md:py-2 border md:rounded-[12px] md:text-base font-semibold";

  return (
    <>
      <div className="w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-6 gap-5">
          {/* INDIA BOX */}
          <div
            className="md:px-4 md:py-2 px-3 py-2 rounded-[16px] border border-[#39F] backdrop-blur-[4px]"
            style={{
              background:
                "linear-gradient(0deg, rgba(51, 153, 255, 0.04) 0%, rgba(51, 153, 255, 0.04) 100%), rgba(255, 255, 255, 0.04)",
            }}
          >
            <div className="flex justify-between">
              <h4 className="text-[#061A2F] md:text-base text-sm font-semibold">
                INDIA
              </h4>
              <p className="text-[#061A2F] md:text-base text-sm font-medium">
                {indiaCities.length} Cities
              </p>
            </div>

            {/* Buttons */}
            <div className="flex flex-wrap md:gap-x-3 gap-y-2 md:gap-y-3 md:my-3">
              {indiaCities.map((city) => (
                <button
                  key={city.name}
                  onClick={() => setActiveIndia(city.name)}
                  className={`${buttonClasses} ${
                    activeIndia === city.name
                      ? "bg-[#39F] text-white border-[#39F]"
                      : "bg-white text-[#39F] border-[#C9C9C9] hover:text-white hover:bg-[#39F] hover:border-[#39F]"
                  }`}
                >
                  {city.name}
                </button>
              ))}
            </div>

            {/* Active City Card */}
            <div className="relative rounded-r-[12px]">
              <Image
                src={activeIndiaCity.image}
                alt={activeIndiaCity.name}
                className="rounded-[11px] w-full md:my-2"
                width={520}
                height={245}
                loading="lazy"
              />
              <div
                className="md:px-[18px] md:py-3 px-3 py-2 backdrop-blur-[26px] absolute top-0 right-0 h-full w-[255px] rounded-r-[12px]"
                style={{
                  background:
                    "linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), rgba(51, 153, 255, 0.10)",
                }}
              >
                <p className="text-white md:text-lg font-semibold text-center uppercase">
                  {activeIndiaCity.name}
                </p>
                <p className="text-white md:text-xs font-normal text-center md:mt-1">
                  {activeIndiaCity.address}
                </p>
                <a
                  href={`tel:${activeIndiaCity.phone_no}`}
                  className="flex justify-center items-center mt-2 text-white md:text-xs font-normal underline"
                >
                  <Image
                    src="https://ik.imagekit.io/mileseducation/miles_website/contact-us/phone_white.webp"
                    alt="phone"
                    width={14}
                    height={14}
                    loading="lazy"
                    className="mr-1"
                  />
                  {activeIndiaCity.phone}
                </a>
                <a
                  href={`mailto:${activeIndiaCity.email}`}
                  className="flex items-center justify-center mt-1 text-white md:text-xs font-normal underline"
                >
                  <Image
                    src="https://ik.imagekit.io/mileseducation/miles_website/contact-us/mail_white.webp"
                    alt="mail"
                    className="mr-1"
                    width={14}
                    height={14}
                    loading="lazy"
                  />
                  {activeIndiaCity.email}
                </a>
                <ChatWithUs
                  phoneNumber="918951235490"
                  whatsappMessage="Hello, I have a question about Miles' Courses."
                />
                <button
                  onClick={() => handleFormModelOpenIndia(activeIndiaCity.name)}
                  className="flex items-center justify-center md:mt-3 bg-transparent border border-white md:rounded-3xl md:py-[5px] md:px-5 w-full text-white md:text-sm font-bold"
                >
                  Visit Office
                </button>
                {activeIndiaCity && (
                  <a
                    href={activeIndiaCity.link}
                    className="flex items-center justify-center md:mt-3 bg-transparent w-full text-white md:text-sm font-bold"
                  >
                    <Image
                      src="https://ik.imagekit.io/mileseducation/miles_website/contact-us/arrow.webp"
                      alt="arrow"
                      className="mr-2"
                      width={14}
                      height={14}
                      loading="lazy"
                    />
                    Know More
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* INTERNATIONAL BOX */}
          <div
            className="md:px-4 md:py-2 px-3 py-2 rounded-[16px] border border-[#39F] backdrop-blur-[4px]"
            style={{
              background:
                "linear-gradient(0deg, rgba(51, 153, 255, 0.04) 0%, rgba(51, 153, 255, 0.04) 100%), rgba(255, 255, 255, 0.04)",
            }}
          >
            <div className="flex justify-between">
              <h4 className="text-[#061A2F] md:text-base text-sm font-semibold">
                INTERNATIONAL
              </h4>
              <p className="text-[#061A2F] md:text-base text-sm font-medium">
                {intlCities.length} Cities
              </p>
            </div>

            {/* Buttons */}
            <div className="flex flex-wrap md:gap-x-4 gap-y-2 md:gap-y-3 md:my-3">
              {intlCities.map((city) => (
                <button
                  key={city.name}
                  onClick={() => setActiveIntl(city.name)}
                  className={`${buttonClasses} md:w-[48.5%] ${
                    activeIntl === city.name
                      ? "bg-[#39F] text-white border-[#39F]"
                      : "bg-white text-[#39F] border-[#C9C9C9] hover:text-white hover:bg-[#39F] hover:border-[#39F]"
                  }`}
                >
                  {city.name}
                </button>
              ))}
            </div>

            {/* Active City Card */}
            <div className="relative rounded-r-[12px]">
              <Image
                src={activeIntlCity.image}
                alt={activeIntlCity.name}
                className="rounded-[11px] w-full md:my-2"
                width={520}
                height={245}
                loading="lazy"
              />
              <div
                className="md:px-[18px] md:py-3 px-3 py-2 backdrop-blur-[26px] absolute top-0 right-0 h-full w-[255px] rounded-r-[12px]"
                style={{
                  background:
                    "linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), rgba(51, 153, 255, 0.10)",
                }}
              >
                <p className="text-white md:text-lg font-semibold text-center uppercase">
                  {activeIntlCity.name}
                </p>
                <p className="text-white md:text-xs font-normal text-center md:mt-1 px-[5px]">
                  {activeIntlCity.address}
                </p>
                <a
                  href={`tel:${activeIntlCity.phone}`}
                  className="flex justify-center items-center mt-2 text-white md:text-xs font-normal underline"
                >
                  <Image
                    src="https://ik.imagekit.io/mileseducation/miles_website/contact-us/phone_white.webp"
                    alt="phone"
                    width={14}
                    height={14}
                    loading="lazy"
                    className="mr-1"
                  />
                  {activeIntlCity.phone}
                </a>
                <a
                  href={`mailto:${activeIntlCity.email}`}
                  className="flex items-center justify-center mt-1 text-white md:text-xs font-normal underline"
                >
                  <Image
                    src="https://ik.imagekit.io/mileseducation/miles_website/contact-us/mail_white.webp"
                    alt="mail"
                    className="mr-1"
                    width={14}
                    height={14}
                    loading="lazy"
                  />
                  {activeIntlCity.email}
                </a>
                <ChatWithUs
                  phoneNumber="918951235490"
                  whatsappMessage="Hello, I have a question about Miles' Courses."
                />
                <button
                  onClick={handleFormModelOpenInternational}
                  className="flex items-center justify-center md:mt-3 bg-transparent border border-white md:rounded-3xl md:py-[5px] md:px-5 w-full text-white md:text-sm font-bold"
                >
                  Visit Office
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isFormModelOpenIndia && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-[999] lg:p-10 p-4">
          <div
            className="rounded-2xl shadow-lg relative h-[auto] mx-auto border border-white p-4 w-[400px]"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
              boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
              backdropFilter: "blur(28px)",
            }}
          >
            <button
              onClick={handleFormModelCloseIndia}
              className="text-white text-2xl absolute right-0 top-1 cursor-pointer"
            >
              ✕
            </button>
            <div>
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
                alt="star group"
                width={34}
                height={38}
                className="absolute top-3 left-[-8px]"
                loading="lazy"
              />
              <GlobalForm
                formType="contact_us"
                formHeading={FormHeading.CONTACT_US}
                pageType={OtherFormCategory.CONTACT_US}
                submitButtonName="Get In Touch"
                showSVG={false}
                successMessage={SuccessMessageType.CONTACT_US}
                darkBackground={true}
                defaultCityLocation={modalDefaultCity ?? undefined}
                isAStepperForm={true}
              />
            </div>
          </div>
        </div>
      )}

      {isFormModelOpenInternational && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-[999] lg:p-10 p-4">
          <div
            className="rounded-2xl shadow-lg relative h-[auto] mx-auto border border-white p-4 w-[400px]"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
              boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
              backdropFilter: "blur(28px)",
            }}
          >
            <button
              onClick={handleFormModelCloseInternational}
              className="text-white text-2xl absolute right-0 top-1 cursor-pointer"
            >
              ✕
            </button>
            <div>
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
                alt="star group"
                width={34}
                height={38}
                className="absolute top-3 left-[-8px]"
                loading="lazy"
              />
              <GlobalForm
                formType="contact_us"
                formHeading={FormHeading.CONTACT_US}
                pageType={OtherFormCategory.CONTACT_US}
                submitButtonName="Get In Touch"
                showSVG={false}
                successMessage={SuccessMessageType.CONTACT_US}
                darkBackground={true}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GlobalPresenceDesktop;
